import { Button } from "@/components/ui/button";
import { Loader2 } from 'lucide-react';
import type { BatchStatus } from './types';

interface UploadButtonsProps {
    batchStatus: BatchStatus;
    onConfirmUpload: () => void;
    onReset: () => void;
    readyFilesCount: number;
}

export const UploadButtons = ({ batchStatus, onConfirmUpload, onReset, readyFilesCount }: UploadButtonsProps) => {
    return (
        <div className="flex justify-end gap-2 mt-6">
            {batchStatus === 'idle' && (
                <>
                    <Button variant="outline" onClick={onReset}>Clear All</Button>
                    <Button onClick={onConfirmUpload} disabled={readyFilesCount === 0}>
                        Create Assets
                    </Button>
                </>
            )}
            {batchStatus === 'processing' && (
                <Button disabled>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Processing...
                </Button>
            )}
            {batchStatus === 'finished' && (
                <Button onClick={onReset}>Upload More</Button>
            )}
        </div>
    );
};